import moment from 'moment'
import { IOrderProps } from './Order'
import { IUserProps } from './User'
import { PaymentHospital, PaymentProperties } from '@/infrastructure/network/Monitaro/schema/models'

export interface IPaymentProps {
  id?: string
  userId: string | null
  user?: IUserProps | null
  hospitalId: string | null
  order?: IOrderProps | null
  orderId: string | null
  amount: number | null
  term: number | null
  limitAt: string | null
  createdAt: string | null
  updatedAt: string | null
  hospital?: PaymentHospital | null
  properties: PaymentProperties | null
}

export default class PaymentEntity {
  private _props: IPaymentProps

  constructor(props?: IPaymentProps | null) {
    this._props = EmptyPaymentPropsFactory(props)
  }

  get props(): IPaymentProps {
    return this._props
  }

  get clone(): IPaymentProps {
    return structuredClone(this._props)
  }

  get id(): string | undefined {
    return this._props.id
  }

  get userId(): string | null {
    return this._props.userId
  }

  get hospitalId(): string | null {
    return this._props.hospitalId
  }

  get orderId(): string | null {
    return this._props.orderId
  }

  get amount(): number | null {
    return this._props.amount
  }

  get term(): string {
    const term: any = { 1: '1ヶ月', 6: '6ヶ月', 12: '12ヶ月' }
    return term[this._props.term || 1] + ' (' + moment(this._props.limitAt).format('YYYY年MM月') + 'まで有効)'
  }

  get limitAt(): string | null {
    return this._props.limitAt
  }

  get createdAt(): string | null {
    return this._props.createdAt
  }

  get updatedAt(): string | null {
    return this._props.updatedAt
  }

  get hospital(): PaymentHospital | null | undefined {
    return this._props.hospital
  }

  get properties(): PaymentProperties | null | undefined {
    return this._props.properties
  }
}

export const headers = [
  { text: '病院名', value: 'hospital', class: 'max' },
  { text: 'お支払い期間', value: 'term' },
  { text: '金額', value: 'amount' },
  { text: '', value: '' }
]

export const EmptyPaymentPropsFactory = (props?: Partial<IPaymentProps> | null): IPaymentProps => ({
  userId: null,
  hospitalId: null,
  orderId: null,
  amount: null,
  term: null,
  limitAt: null,
  createdAt: null,
  updatedAt: null,
  properties: null,
  ...props
})
